import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
);

// This app must always load fresh (it is a live monitoring dashboard), so we
// do NOT register a precaching service worker. unregister() also removes any
// stale worker left over from older builds. See public/service-worker.js for
// the tombstone that heals existing "Add to Home Screen" installs.
serviceWorkerRegistration.unregister();